import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerProvider } from './server';

@Injectable()
export class AgendamentoProvider {

  constructor(public server: ServerProvider) {
  }

  buscarDias(): Observable<any> {
    return this.server.postData({ "operacao": "DIAS_AGENDAMENTO_LISTAR" });
  }

  buscarHorarios(data: string): Observable<any> {
    return this.server.postData({ "operacao": "HORARIOS_AGENDAMENTO_LISTAR", "data": data });
  }

  buscarAgedamentos(): Observable<any> {
    return this.server.postData({ "operacao": "AGENDAMENTO_LISTAR" });
  }

  marcarAgendamento(agendamento): Observable<any> {
    return this.server.postData({ "operacao": "AGENDAMENTO_ADICIONAR", "agendamento": agendamento });
  }

  cancelar(agendamentoId): Observable<any> {
    return this.server.postData({ "operacao": "AGENDAMENTO_CANCELAR", "agendamentoId": agendamentoId });
  }
}



// WEBPACK FOOTER //
// ./src/providers/agendamento.ts